export const CommunityApiEndpoint = {
  /**
   * boardId 값들
   * news: 공지사항
   * event: 이벤트
   * join: 조인
   * archive: 자료실
   * 새 분류가 필요한 경우 boardId를 추가
   */
  fetchPostId: '/boards/:boardId/posts', // POST: 게시글 ID 생성
  updatePost: '/boards/:boardId/posts', // PATCH: 게시글 등록 및 수정
  fetchPostList: '/normal-boards/:boardId/posts/search', // GET: 게시글 목록 조회
  fetchPost: '/boards/:boardId/posts/search/:postId', // GET: 게시글 상세보기
  deletePost: '/boards/:boardId/posts/:postId', // DELETE: 게시글 삭제
  fetchMainBoards: '/main/boards', // GET: 메인화면에 노출될 게시글 리스트
  fetchMainBanners: '/banners', // GET: 메인화면에 노출될 배너 리스트
  updatePostImage: '/boards/:boardId/posts/:postId/image', // POST: 게시글 내 이미지 등록(MCKEditor에 하드코딩되어있음)
  // 이벤트 및 공지 통합...
  // fetchEventList: '/event-boards/:boardId/posts/search', // GET: 게시글 목록 조회(이벤트)
  // fetchEvent: '/event-boards/:boardId/posts/:postId', // GET: 게시글 상세보기(이벤트)
  // fetchTotalPost: '/boards/:boardId/posts/search/:postId', // GET: 게시글 상세보기(이벤트 제외 모두다 이거 사용)
};
